import { Button } from '../../../components/Clickables/Buttons/Button';
import { Container } from '../../../components/Container/Container';
import { Heading } from '../../../components/Heading/Heading';
import { ErrorCheckoutIcon } from '../../../components/Icons/ErrorCheckoutIcon';
import { Text } from '../../../components/Text/Text';

interface IProps {
  isNotAppPage: boolean;
  onNavigateBack: () => void;
}

export const SuggestionError = ({ isNotAppPage, onNavigateBack }: IProps) => {
  return (
    <Container
      className="mt-10 flex flex-col items-center gap-4 text-center md:mt-14"
      variant="thin"
    >
      <ErrorCheckoutIcon size={104} />
      <Heading variant="sm">Something went wrong</Heading>
      <div className="w-full">
        <Text variant="sm">
          Looks like something went wrong. Your review was not saved. Please check your internet
          connection or try again later
        </Text>
      </div>
      {isNotAppPage && (
        <Button variant="buttonPrimary" className="max-w-prose" onClick={onNavigateBack}>
          Back to Suggest changes
        </Button>
      )}
    </Container>
  );
};
